export const common = {
  // Navigation
  home: 'होम',
  search: 'खोजें',
  matches: 'मैच',
  messages: 'संदेश',
  successStories: 'सफलता की कहानियां',
  login: 'लॉगिन',
  register: 'मुफ्त रजिस्टर करें',
  
  // Common Actions
  submit: 'जमा करें',
  cancel: 'रद्द करें',
  save: 'सेव करें',
  edit: 'संपादित करें',
  delete: 'हटाएं',
  view: 'देखें',
  close: 'बंद करें',
  next: 'अगला',
  previous: 'पिछला',
  
  // Form Fields
  name: 'नाम',
  email: 'ईमेल',
  phone: 'फोन',
  age: 'उम्र',
  location: 'स्थान',
  country: 'देश',
  city: 'शहर',
  profession: 'पेशा',
  education: 'शिक्षा',
  religion: 'धर्म',
  caste: 'जाति',
  motherTongue: 'मातृभाषा',
  maritalStatus: 'वैवाहिक स्थिति',
  
  // Marital Status Options
  neverMarried: 'कभी शादी नहीं हुई',
  divorced: 'तलाकशुदा',
  widowed: 'विधवा/विधुर',
  separated: 'अलग',
  
  // Education Levels
  highSchool: 'हाई स्कूल',
  bachelors: 'स्नातक',
  masters: 'स्नातकोत्तर',
  doctorate: 'डॉक्टरेट',
  diploma: 'डिप्लोमा',
  
  // Professions
  engineer: 'इंजीनियर',
  doctor: 'डॉक्टर',
  teacher: 'शिक्षक',
  businessman: 'व्यापारी',
  lawyer: 'वकील',
  consultant: 'सलाहकार',
  other: 'अन्य',
  
  // Common Messages
  loading: 'लोड हो रहा है...',
  error: 'कुछ गलत हुआ',
  success: 'सफल!',
  noResults: 'कोई परिणाम नहीं मिला',
  tryAgain: 'फिर कोशिश करें',
  
  // Time
  today: 'आज',
  yesterday: 'कल',
  thisWeek: 'इस सप्ताह',
  thisMonth: 'इस महीने',
  
  // Premium
  premium: 'प्रीमियम',
  upgrade: 'अपग्रेड',
  choosePlan: 'प्लान चुनें',
  
  // Footer
  aboutUs: 'हमारे बारे में',
  contactUs: 'संपर्क करें',
  privacyPolicy: 'गोपनीयता नीति',
  termsOfService: 'सेवा की शर्तें',
  helpCenter: 'सहायता केंद्र',
  
  // Global Features
  worldwide: 'विश्वव्यापी',
  international: 'अंतर्राष्ट्रीय',
  globalCommunity: 'वैश्विक समुदाय',
  findLoveAnywhere: 'कहीं भी प्यार खोजें',
  connectGlobally: 'विश्व स्तर पर जुड़ें',

  // Hero Section
  heroTitle: 'अपना परफेक्ट जीवनसाथी खोजें',
  heroSubtitle: 'दुनिया भर से हजारों सत्यापित प्रोफाइल में शामिल हों और विश्वास और सम्मान के साथ अपना जीवनसाथी खोजें।',
  getStartedFree: 'मुफ्त शुरू करें',
  browseProfiles: 'प्रोफाइल देखें',
  verifiedProfiles: 'सत्यापित और वास्तविक प्रोफाइल',
  privacyFocused: 'गोपनीयता-केंद्रित और सुरक्षित प्लेटफॉर्म',
  meaningfulConnections: 'सार्थक कनेक्शन के लिए डिज़ाइन किया गया',

  // Features Section
  whyChoose: 'हमारा प्लेटफॉर्म क्यों चुनें?',
  whyChooseSubtitle: 'हम आपको अपना परफेक्ट जीवनसाथी खोजने में मदद करने के लिए उन्नत सुविधाओं के साथ सबसे विश्वसनीय और व्यापक मैट्रिमोनी सेवा प्रदान करते हैं',
  verifiedProfilesTitle: 'सत्यापित प्रोफाइल',
  verifiedProfilesDesc: 'आपकी सुरक्षा के लिए सभी प्रोफाइल आईडी प्रूफ और बैकग्राउंड चेक के साथ मैन्युअल रूप से सत्यापित हैं।',
  advancedSearchTitle: 'उन्नत खोज',
  advancedSearchDesc: 'शिक्षा, पेशा, पारिवारिक पृष्ठभूमि और अधिक सहित विस्तृत फ़िल्टर के साथ अपना परफेक्ट मैच खोजें।',
  secureMessagingTitle: 'सुरक्षित मैसेजिंग',
  secureMessagingDesc: 'गोपनीयता नियंत्रण के साथ हमारी सुरक्षित मैसेजिंग सिस्टम के माध्यम से संभावित मैच से जुड़ें।',
  compatibilityMatchingTitle: 'संगतता मिलान',
  compatibilityMatchingDesc: 'हमारा AI-संचालित एल्गोरिदम आपकी प्राथमिकताओं और मूल्यों के आधार पर अत्यधिक संगत मैच सुझाता है।',
  support247Title: '24/7 सहायता',
  support247Desc: 'किसी भी समय हमारे समर्पित रिलेशनशिप काउंसलर और ग्राहक सहायता टीम से सहायता प्राप्त करें।',
  successStoriesTitle: 'सफलता की कहानियां',
  successStoriesDesc: 'हजारों खुश जोड़ों में शामिल हों जिन्होंने हमारे प्लेटफॉर्म के माध्यम से अपने जीवनसाथी पाए।',

  // Profile Page
  myProfile: 'मेरी प्रोफाइल',
  manageProfile: 'अपनी प्रोफाइल जानकारी प्रबंधित करें',
  editProfile: 'प्रोफाइल संपादित करें',
  saveProfile: 'प्रोफाइल सेव करें',
  saveChanges: 'परिवर्तन सेव करें',
  discardChanges: 'परिवर्तन रद्द करें',
  saving: 'सेव हो रहा है...',
  savingChanges: 'परिवर्तन सेव हो रहे हैं...',
  
  // Profile Tabs
  basicInfo: 'बुनियादी जानकारी',
  photos: 'फोटो',
  family: 'परिवार',
  partnerPreferences: 'साथी की प्राथमिकताएं',
  
  // Profile Fields
  fullName: 'पूरा नाम',
  phoneNumber: 'फोन नंबर',
  gender: 'लिंग',
  height: 'ऊंचाई',
  annualIncome: 'वार्षिक आय',
  occupation: 'पेशा',
  aboutMe: 'मेरे बारे में',
  familyType: 'परिवार का प्रकार',
  familyValues: 'पारिवारिक मूल्य',
  familyStatus: 'पारिवारिक स्थिति',
  
  // Profile Placeholders
  enterFullName: 'अपना पूरा नाम दर्ज करें',
  enterPhone: '+91 1234567890',
  enterAge: 'अपनी उम्र दर्ज करें',
  selectGender: 'लिंग चुनें',
  enterHeight: 'उदा., 5\'8"',
  selectMaritalStatus: 'स्थिति चुनें',
  enterReligion: 'अपना धर्म दर्ज करें',
  enterCaste: 'अपनी जाति दर्ज करें',
  enterMotherTongue: 'अपनी मातृभाषा दर्ज करें',
  enterEducation: 'अपनी शिक्षा दर्ज करें',
  enterOccupation: 'अपना पेशा दर्ज करें',
  enterIncome: 'उदा., 5 LPA',
  enterLocation: 'शहर, राज्य',
  writeAbout: 'अपने बारे में संक्षिप्त विवरण लिखें...',
  
  // Gender Options
  male: 'पुरुष',
  female: 'महिला',
  otherGender: 'अन्य',
  
  // Family Options
  nuclearFamily: 'एकल परिवार',
  jointFamily: 'संयुक्त परिवार',
  traditional: 'पारंपरिक',
  moderate: 'मध्यम',
  liberal: 'उदार',
  middleClass: 'मध्यम वर्ग',
  upperMiddleClass: 'उच्च मध्यम वर्ग',
  rich: 'अमीर',
  affluent: 'संपन्न',
  
  // Partner Preferences
  preferredAgeRange: 'पसंदीदा आयु सीमा',
  preferredHeight: 'पसंदीदा ऊंचाई',
  preferredEducation: 'पसंदीदा शिक्षा',
  preferredOccupation: 'पसंदीदा पेशा',
  preferredLocation: 'पसंदीदा स्थान',
  preferredReligion: 'पसंदीदा धर्म',
  
  // Profile Photos
  profilePhotos: 'प्रोफाइल फोटो',
  uploadPhotosDesc: 'अपनी प्रोफाइल पूरी करने के लिए कम से कम एक फोटो अपलोड करें',
  
  // Welcome Messages
  welcomeTitle: 'शादीपरिवार में आपका स्वागत है! 🎉',
  completeProfile: 'अपना परफेक्ट मैच खोजना शुरू करने के लिए अपनी प्रोफाइल पूरी करें',
  fillRequiredFields: 'सभी आवश्यक फ़ील्ड भरें और कम से कम एक फोटो अपलोड करें',
  
  // Subscription Prompt
  upgradeToPremium: 'प्रीमियम में अपग्रेड करें',
  unlimitedAccess: 'सभी सुविधाओं तक असीमित पहुंच प्राप्त करें',
  unlimitedMessaging: 'असीमित मैसेजिंग',
  seeWhoViewed: 'देखें किसने आपको देखा',
  advancedFilters: 'उन्नत फ़िल्टर',
  prioritySupport: 'प्राथमिकता सहायता',
  viewPlans: 'प्लान देखें',
  maybeLater: 'शायद बाद में',
  
  // Profile Actions
  unsavedChanges: 'आपके पास असहेजे परिवर्तन हैं',
  saveToKeep: 'अपने अपडेट रखने के लिए अपनी प्रोफाइल सेव करें',
  confirmDiscard: 'क्या आप वाकई अपने परिवर्तनों को रद्द करना चाहते हैं?',
  
  // Profile Status Messages
  loadingProfile: 'आपकी प्रोफाइल लोड हो रही है...',
  unableToLoad: 'प्रोफाइल लोड करने में असमर्थ',
  sessionExpired: 'सत्र समाप्त हो गया। कृपया फिर से साइन इन करें।',
  tryAgainButton: 'फिर कोशिश करें',
  profileSaved: 'प्रोफाइल सफलतापूर्वक अपडेट की गई!',
  failedToSave: 'प्रोफाइल सेव करने में विफल',
  
  // Character Count
  characters: 'अक्षर',
  
  // Required Field
  required: '*',
  
  // Profile Menu
  myMatches: 'मेरे मैच',
  myMessages: 'संदेश',
  upgradeToPremiumMenu: 'प्रीमियम में अपग्रेड करें',
  logout: 'लॉगआउट',
  viewProfile: 'प्रोफाइल देखें',
  
  // Help
  help: 'सहायता',
  
  // Select Options
  selectCountry: 'देश चुनें',
  selectFamilyType: 'परिवार का प्रकार चुनें',
  selectFamilyValues: 'पारिवारिक मूल्य चुनें',
  selectFamilyStatus: 'पारिवारिक स्थिति चुनें',
  
  // Marital Status Full
  awaitingDivorce: 'तलाक की प्रतीक्षा में',
  
  // Partner Preference Placeholders
  ageRangePlaceholder: 'उदा., 25-30',
  heightRangePlaceholder: 'उदा., 5\'6" - 6\'0"',
  enterPreferredEducation: 'पसंदीदा शिक्षा दर्ज करें',
  enterPreferredOccupation: 'पसंदीदा पेशा दर्ज करें',
  enterPreferredLocation: 'पसंदीदा स्थान दर्ज करें',
  enterPreferredReligion: 'पसंदीदा धर्म दर्ज करें',
  
  // Profile Photo Visibility
  photoVisibility: 'फोटो दृश्यता',
  privacySettings: 'गोपनीयता सेटिंग्स',
  controlWhoSees: 'नियंत्रित करें कि आपकी प्रोफ़ाइल फोटो कौन देख सकता है',
  visibilityOptions: 'दृश्यता विकल्प',
  showToEveryone: 'सभी को दिखाएं',
  showToEveryoneDesc: 'आपकी फोटो सभी उपयोगकर्ताओं को दिखाई देती है',
  showToPremiumOnly: 'केवल प्रीमियम सदस्यों को दिखाएं',
  showToPremiumOnlyDesc: 'केवल प्रीमियम सदस्य आपकी फोटो देख सकते हैं',
  showToFreeOnly: 'केवल मुफ्त उपयोगकर्ताओं को दिखाएं',
  showToFreeOnlyDesc: 'केवल मुफ्त उपयोगकर्ता आपकी फोटो देख सकते हैं',
  hideFromEveryone: 'सभी से छिपाएं',
  hideFromEveryoneDesc: 'आपकी फोटो सभी उपयोगकर्ताओं से छिपी हुई है',
  customVisibility: 'कस्टम दृश्यता',
  customVisibilityDesc: 'विशिष्ट उपयोगकर्ताओं से छिपाने के लिए चुनें',
  hideFromSpecificUsers: 'विशिष्ट उपयोगकर्ताओं से छिपाएं',
  enterUserIds: 'उपयोगकर्ता आईडी दर्ज करें (अल्पविराम से अलग)',
  userIdsPlaceholder: 'उदाहरण: user123, user456',
  visibilityUpdated: 'फोटो दृश्यता सेटिंग्स सफलतापूर्वक अपडेट की गईं',
  visibilityUpdateFailed: 'दृश्यता सेटिंग्स अपडेट करने में विफल',
  photoHiddenForYou: 'उपयोगकर्ता द्वारा फोटो छिपाई गई',
  premiumOnlyPhoto: 'देखने के लिए प्रीमियम में अपग्रेड करें',
  privacyNote: 'गोपनीयता नोट',
  privacyNoteDesc: 'आपकी गोपनीयता सेटिंग्स तुरंत लागू हो जाएंगी। जो उपयोगकर्ता आपकी फोटो नहीं देख सकते, उन्हें एक प्लेसहोल्डर छवि दिखाई देगी।',
};
